export default __webpack_public_path__ + "static/media/bullet-point.dd0de8d4.svg";